import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.ends-with.js";
import { __decorate } from "tslib";
import Component from "vue-class-component";
import Vue from "vue";
import { Watch } from "vue-property-decorator";
import MatImage from "./MatImage.vue"; // import { Color } from "configurator-base-app/dist/libModules/Colors";

var DEFAULT_TEMPLE_COLOR_CODES = ["PL0001", "EP0001"];
var DEFAULT_METAL_COLOR_CODE = "PRO0000272";
var ABBELLITORE_GUN_COLOR_CODE = "PRO0000849";
var ABBELLITORE_GOLD_COLOR_CODE = "PRO0000850";

var Aste = /*#__PURE__*/function (_Vue) {
  _inherits(Aste, _Vue);

  var _super = _createSuper(Aste);

  function Aste() {
    var _this;

    _classCallCheck(this, Aste);

    _this = _super.apply(this, arguments); // Variabile utilizzata per mostrare il un dialog di warning all'utente quando cambia materiale avendo definito personalizzazioni

    _this.sicuroCambioMateriale = false; // Materiale selezionato dall'utente nel filtro

    _this.matFiltro = _this.templesColor && String(_this.templesColor.METALTEMPLE) == "1" ? "MT" : "PL";
    _this.findTempleColor = "";
    _this.activeTemple = _this.templesColor ? _this.templesColor : null; // Ricorda il materiale che l'utente vuole selezionare quando mostri il dialog "Sicuro di voler cambiare materiale?"

    _this.materialToChange = null; // Ricorda le aste che l'utente vuole selezionare quando mostri il dialog "Sicuro di voler cambiare materiale?"

    _this.templeToActivate = null;
    return _this;
  }

  _createClass(Aste, [{
    key: "temples",
    get: function get() {
      return this.$store.getters.filteredTemples;
    }
  }, {
    key: "tipoAbbellitore",
    get: function get() {
      return this.$store.state.configurator.abbellitore == null ? "A" : "B";
    },
    set: function set(newV) {
      this.$store.commit("configurator/setAbbellitore", newV == "A" ? null : this.getAbbellitoreForMetalColor(this.coloreMetalloAste));
    }
  }, {
    key: "materialePerFiltro",
    get: function get() {
      if (this.$store.state.affogatiEnabled) return "PL";
      return this.matFiltro;
    },
    set: function set(m) {
      this.changeTemplesMaterial(m);
    }
  }, {
    key: "sizesAvailables",
    get: function get() {
      var availableSizes = [];

      for (var i = 0; i < this.temples.length; i++) {
        if (this.materialePerFiltro == "PL") {
          if (this.isTempleMaterial(this.temples[i], "PL") && availableSizes.indexOf(this.temples[i].U_THE_LUNGASTA) < 0) {
            availableSizes.push(this.temples[i].U_THE_LUNGASTA);
          }
        } else {
          if (this.isTempleMaterial(this.temples[i], "MT") && availableSizes.indexOf(this.temples[i].U_THE_LUNGASTA) < 0) {
            availableSizes.push(this.temples[i].U_THE_LUNGASTA);
          }
        }
      } // Ordina le lunghezze in ordine crescente


      return availableSizes.sort(function (a, b) {
        return parseInt(a) - parseInt(b);
      });
    }
  }, {
    key: "filteredTemples",
    get: function get() {
      var _this2 = this;

      var result = this.temples;
      var q = this.findTempleColor;

      if (q) {
        result = result.filter(function (t) {
          // return _.includes(t.U_THE_COLORE, q);
          return t.U_THE_COLORE.indexOf(q) > -1;
        });
      }

      if (this.materialePerFiltro) {
        result = result.filter(function (t) {
          if (_this2.materialePerFiltro == "PL") {
            return _this2.isTempleMaterial(t, "PL");
          } else {
            return _this2.isTempleMaterial(t, "MT");
          } //return t.materiale == this.materiale

        });
      }

      if (this.misuraAste) {
        result = result.filter(function (t) {
          return t.U_THE_LUNGASTA == _this2.misuraAste;
        });
      }

      return result;
    }
  }, {
    key: "frontale",
    get: function get() {
      return this.$store.state.configurator.frontale;
    }
  }, {
    key: "finituraFrontale",
    get: function get() {
      return this.$store.state.configurator.finitura;
    }
  }, {
    key: "templesColor",
    get: function get() {
      return this.$store.state.configurator.coloreAste;
    }
  }, {
    key: "misuraAste",
    get: function get() {
      return this.$store.state.configurator.misuraAste;
    },
    set: function set(ma) {
      this.$store.commit("configurator/setTemplesSize", ma);
    }
  }, {
    key: "finituraAste",
    get: function get() {
      return this.$store.state.configurator.finituraAste;
    },
    set: function set(fa) {
      this.$store.commit("configurator/setTemplesFinishing", fa);
    }
  }, {
    key: "materiale",
    get: function get() {
      return this.$store.state.configurator.templesMaterial;
    },
    set: function set(m) {
      this.$store.commit("configurator/setTemplesMaterial", m);
    }
  }, {
    key: "coloreMetalloAste",
    get: function get() {
      return this.$store.state.configurator.coloreMetalloAste;
    },
    set: function set(c) {
      if (this.materiale == "MT" || this.materialePerFiltro == "MT") {
        this.$store.commit("configurator/setTemplesMetalColor", c);
      }

      if (this.tipoAbbellitore != "A") {
        this.$store.commit("configurator/setAbbellitore", this.getAbbellitoreForMetalColor(c));
      }
    }
  }, {
    key: "presentiPersonalizzazioniAste",
    get: function get() {
      var aste = this.$store.state.configurator.aste;
      return [aste.extSxName, aste.extSxNameColor, aste.intSxName, aste.intSxNameColor, aste.extDxName, aste.extDxNameColor, aste.intDxName, aste.intDxNameColor].some(function (value) {
        return value != null && value !== "";
      });
    } // noTempleAvailable() {
    //   if (this.filteredTemples.length == 0) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }

  }, {
    key: "setTemplesColor",
    value: function setTemplesColor(t) {
      this.$store.commit("configurator/setTemplesColor", t);
    }
  }, {
    key: "setTemplesMaterial",
    value: function setTemplesMaterial(tm) {
      this.$store.commit("configurator/setTemplesMaterial", tm);
    }
  }, {
    key: "unsetTemplesMetalColor",
    value: function unsetTemplesMetalColor() {
      this.$store.commit("configurator/unsetTemplesMetalColor");
    }
  }, {
    key: "resetPersonalizzazioniAste",
    value: function resetPersonalizzazioniAste() {
      this.$store.commit("resetPersonalizzazioniAste");
    }
  }, {
    key: "getAbbellitoreForMetalColor",
    value: function getAbbellitoreForMetalColor(colorCode) {
      return !colorCode || colorCode == DEFAULT_METAL_COLOR_CODE ? ABBELLITORE_GUN_COLOR_CODE : ABBELLITORE_GOLD_COLOR_CODE;
    }
  }, {
    key: "isTempleMaterial",
    value: function isTempleMaterial(t, material) {
      return String(t.METALTEMPLE) == (material == "MT" ? "1" : "0");
    }
  }, {
    key: "getTempleMaterial",
    value: function getTempleMaterial(t) {
      return this.isTempleMaterial(t, "MT") ? "MT" : "PL";
    }
  }, {
    key: "findDefaultTemple",
    value: function findDefaultTemple(temples) {
      return temples.find(function (t) {
        return DEFAULT_TEMPLE_COLOR_CODES.includes(t.U_THE_COLORE);
      }) || temples.find(function (t) {
        return t.U_THE_COLORE.endsWith("0001");
      }) || null;
    }
  }, {
    key: "findTempleForMaterial",
    value: function findTempleForMaterial(material, referenceTemple) {
      var _this3 = this;

      var materialTemples = this.temples.filter(function (t) {
        return _this3.isTempleMaterial(t, material);
      });

      if (materialTemples.length == 0) {
        return null;
      }

      var referenceSize = (referenceTemple === null || referenceTemple === void 0 ? void 0 : referenceTemple.U_THE_LUNGASTA) || this.misuraAste || null;
      var sameSizeTemples = referenceSize ? materialTemples.filter(function (t) {
        return t.U_THE_LUNGASTA == referenceSize;
      }) : [];
      var candidates = sameSizeTemples.length > 0 ? sameSizeTemples : materialTemples;
      return this.findDefaultTemple(candidates) || candidates[0];
    }
  }, {
    key: "changeTemplesMaterial",
    value: function changeTemplesMaterial(material) {
      this.matFiltro = material;
      var targetTemple = this.findTempleForMaterial(material, this.activeTemple || this.templesColor);

      if (!targetTemple) {
        return;
      }

      if (material != this.materiale && this.presentiPersonalizzazioniAste) {
        this.materialToChange = material;
        this.templeToActivate = targetTemple;
        this.sicuroCambioMateriale = true;
        return;
      }

      this.applyTempleSelection(targetTemple, material, material == "MT");
    }
  }, {
    key: "applyTempleSelection",
    value: function applyTempleSelection(temple) {
      var material = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var resetMetalColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (!temple) {
        return;
      }

      var targetMaterial = material || this.getTempleMaterial(temple);
      this.matFiltro = targetMaterial;
      this.setTemplesMaterial(targetMaterial);

      if (targetMaterial == "MT") {
        if (resetMetalColor) {
          this.setDefaultMetalColor();
        }
      } else {
        this.unsetTemplesMetalColor();
      }

      this.setActiveTemple(temple);
    }
  }, {
    key: "setDefaultMetalColor",
    value: function setDefaultMetalColor() {
      this.coloreMetalloAste = DEFAULT_METAL_COLOR_CODE;
    }
  }, {
    key: "cancelCambioMateriale",
    value: function cancelCambioMateriale() {
      this.matFiltro = this.materiale;
      this.materialToChange = null;
      this.templeToActivate = null;
      this.sicuroCambioMateriale = false;
    }
  }, {
    key: "confirmCambioMateriale",
    value: function confirmCambioMateriale() {
      var material = this.materialToChange || (this.templeToActivate ? this.getTempleMaterial(this.templeToActivate) : this.materiale);
      this.resetPersonalizzazioniAste();
      this.applyTempleSelection(this.templeToActivate, material, material == "MT");
      this.materialToChange = null;
      this.templeToActivate = null;
      this.sicuroCambioMateriale = false;
    }
    /**
     * Verifica se bisogna chiedere all'utente conferma nel caso stia selezionando metallo mentre ha personalizzazioni attive sulle aste
     */

  }, {
    key: "tryActivateTemple",
    value: function tryActivateTemple(t) {
      var targetMaterial = this.getTempleMaterial(t);
      var isChangingToMetal = targetMaterial == "MT" && this.materiale != "MT";

      if (targetMaterial != this.materiale && this.presentiPersonalizzazioniAste) {
        this.matFiltro = targetMaterial;
        this.materialToChange = targetMaterial;
        this.templeToActivate = t;
        this.sicuroCambioMateriale = true;
        return;
      }

      this.applyTempleSelection(t, targetMaterial, isChangingToMetal);
    }
  }, {
    key: "setActiveTemple",
    value: function setActiveTemple(t) {
      if (!t) {
        return;
      }

      this.activeTemple = t;
      this.setTemplesColor(t);

      if (t.U_THE_LUNGASTA != this.misuraAste) {
        this.misuraAste = t.U_THE_LUNGASTA;
      }
    }
  }, {
    key: "canShowMetalColors",
    get: function get() {
      var _this4 = this;

      return this.temples.some(function (t) {
        return _this4.isTempleMaterial(t, "MT");
      });
    }
  }, {
    key: "materialChanged",
    value: function materialChanged(newVal) {
      this.matFiltro = newVal;

      if (newVal == "PL") {
        this.unsetTemplesMetalColor();
      } else if (newVal == "MT") {
        this.setDefaultMetalColor();
      }
    }
  }, {
    key: "misuraAsteChanged",
    value: function misuraAsteChanged(newVal) {
      var _this5 = this;

      /*
          se ho un'asta attiva e cambia la misura
          sostituisco all'asta attiva una con
          stesso colore, stesso materiale e misura selezionata
        */
      var at = this.activeTemple;

      if (at != null) {
        var a = this.temples.filter(function (t) {
          return t.U_THE_COLORE == (at === null || at === void 0 ? void 0 : at.U_THE_COLORE) && _this5.getTempleMaterial(t) == _this5.getTempleMaterial(at) && t.U_THE_LUNGASTA == newVal;
        });

        if (a.length > 0) {
          this.setActiveTemple(a[0]); // } else {
          //   this.noTempleAvailable = true;
        }
      }
    }
  }, {
    key: "templesColorChanged",
    value: function templesColorChanged(newVal) {
      if (!newVal) {
        return;
      } // @ts-ignore
      // eslint-disable-next-line no-undef


      gtag("event", "setAste", {
        event_category: "aste",
        event_label: newVal.ItemName
      });
      this.activeTemple = newVal;
    }
  }]);

  return Aste;
}(Vue);

__decorate([Watch("materiale")], Aste.prototype, "materialChanged", null);

__decorate([Watch("misuraAste")], Aste.prototype, "misuraAsteChanged", null);

__decorate([Watch("templesColor")], Aste.prototype, "templesColorChanged", null);

Aste = __decorate([Component({
  components: {
    MatImage: MatImage
  }
})], Aste);
export default Aste;